import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector } from "react-redux"; //useDispatch

//Components
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import { validateRequired } from "../../../common/Validations";

import ItemService from "../../../services/supplier_appCommonService";
import { getCategoryListData } from "../../../redux/feature/userSlice";

//Redux
import { useDispatch } from "react-redux"; //useDispatch
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import SuccessRegisterModal from "../../../Components/SuccessRegisterModal";
import SupplierConstants from "../../../common/SupplierConstants";

const CategoryDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  localStorage.setItem("menu", "Admin");
  localStorage.setItem("submenu", "Category");

  let categoryDetailsData = useSelector(
    (state) => state?.user?.categoryList?.categoryDetails
  );

  const [isCardVisible, setCardVisible] = useState(true);
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const [formInputs, setFormInputs] = useState({
    CategoryCode: "",
    vendorCategoryText: "",
    vendorSubCategoryText: "",
    vendorSubCategoryCode: "",
    vendorSubCategoryLongText: "",
  });
  const modalData = {
    title: "Category Updated",
    successMsg: "",
  };
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [editMode, setEditMode] = useState(true);

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getFailureModal] = useState(failureModalData);

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);

  /* Edit Button */
  const handleEdit = () => {
    setEditMode(false);
  };
  /* Edit Button */
  const handleEditCategory = async () => {
    let requiredFields = [];
    if (
      !validateRequired(formInputs?.vendorCategoryText) ||
      !validateRequired(formInputs?.vendorSubCategoryText) ||
      !validateRequired(formInputs?.vendorSubCategoryCode) ||
      !validateRequired(formInputs?.vendorSubCategoryLongText)
    ) {
      requiredFields.push("All fields are required..!");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    setDisabled(true);
    await ItemService.updateCategory(formInputs).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();
        // Update response value in Redux Store
        dispatch(getCategoryListData()); // event store
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  useEffect(() => {
    if (categoryDetailsData) {
      setFormInputs(categoryDetailsData);
    } else {
      navigate(SupplierConstants.CATEGORY_LIST);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create Category</h2>
            <p className="subText">Category Group Details</p>
            <hr />

            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CG</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Create Group</span>
                      <span className="subHeaderTitle">Create Group</span>
                    </Col>

                    <Col xs={4} md={2} lg={2} className="text-right">
                      {editMode && (
                        <span>
                          <button className="btnTable" onClick={handleEdit}>
                            Edit
                          </button>
                        </span>
                      )}
                      {!editMode && (
                        <span>
                          <button
                            className="btnTable"
                            disabled={disabled}
                            onClick={handleEditCategory}
                          >
                            Update Category
                          </button>
                        </span>
                      )}
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Category Code"
                          name="CategoryCode"
                          id="CategoryCode"
                          extraLabel=""
                          placeholder="Category Code"
                          value={formInputs.CategoryCode || ""}
                          onChange={onInputChange}
                          disabled={true}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Category"
                          name="vendorCategoryText"
                          id="vendorCategoryText"
                          placeholder="vendorCategoryText"
                          value={formInputs.vendorCategoryText || ""}
                          onChange={onInputChange}
                          disabled={editMode}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="SubCategory"
                          name="vendorSubCategoryText"
                          id="vendorSubCategoryText"
                          extraLabel=""
                          placeholder="SubCategory"
                          value={formInputs.vendorSubCategoryText || ""}
                          onChange={onInputChange}
                          disabled={editMode}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="SubCategory Code"
                          name="vendorSubCategoryCode"
                          id="vendorSubCategoryCode"
                          extraLabel=""
                          placeholder="SubCategory Code"
                          value={formInputs.vendorSubCategoryCode || ""}
                          onChange={onInputChange}
                          disabled={editMode}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="SubCategory Description"
                          type="text"
                          name="vendorSubCategoryLongText"
                          id="vendorSubCategoryLongText"
                          placeholder="SubCategory Description"
                          value={formInputs.vendorSubCategoryLongText || ""}
                          onChange={onInputChange}
                          disabled={editMode}
                          required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={SupplierConstants.CATEGORY_LIST}
      />
    </main>
  );
};

export default CategoryDetails;
